import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import "@/styles/globals.css";

// Mock auth for development (disabled - using real API)
/*
if (import.meta.env.VITE_ENABLE_MOCK_DATA === 'true') {
  // Auto-login for development with mock user
  const mockUser = {
    id: '1',
    email: 'admin@zipto.in',
    name: 'Admin User',
    role: 'super_admin',
    createdAt: new Date().toISOString(),
  };

  const existingAuth = localStorage.getItem('zipto-auth');
  if (!existingAuth) {
    localStorage.setItem(
      'zipto-auth',
      JSON.stringify({
        state: {
          user: mockUser,
          accessToken: 'mock-access-token',
          refreshToken: 'mock-refresh-token',
          isAuthenticated: true,
        },
        version: 0,
      })
    );
  }
}
*/

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
